export default __webpack_public_path__ + "static/O0043-867e358ee40d288bb3c728a412c70a34.png";